import FallbackSvg from '@/assets/logos/creditCards/00_FallbackCard.svg?url';
import VisaSvg from '@/assets/logos/creditCards/01_Visa.svg?url';
import AmexSvg from '@/assets/logos/creditCards/02_Amex.svg?url';
import DiscoverSvg from '@/assets/logos/creditCards/03_Discover.svg?url';
import MastercardSvg from '@/assets/logos/creditCards/04_Mastercard.svg?url';

const BRAND_MAP: Record<string, string> = {
  Visa: VisaSvg,
  MasterCard: MastercardSvg,
  'American Express': AmexSvg,
  Discover: DiscoverSvg,
};

interface CreditCardBrandLogoProps {
  card_type: string | null;
}

export const CreditCardBrandLogo: React.FC<CreditCardBrandLogoProps> = ({ card_type }) => {
  const src = (card_type && BRAND_MAP[card_type]) ?? FallbackSvg;
  const alt = card_type ?? 'Credit card';

  return (
    <img
      src={src}
      alt={alt}
      height={24}
      width={36}
    />
  );
};
